import { FEDomains } from "./serverUrls";

export const getTermsUrlFromDomain = () => {
  const domain = window.location.hostname;

  switch (domain) {
    case FEDomains.EGY:
      return 'https://paymob.com/en/policy';
    case FEDomains.ARE:
      return 'https://www.paymob.ae/personal-data-protection/';
    case FEDomains.SAU:
      return 'https://www.paymob.sa/personal-data-protection/';
    case FEDomains.OMN:
      return 'https://om.paymob.com/en/policy';
    default:
      return 'https://paymob.com/en/policy';
  }
}